import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { requestOTP, setUserPassword, clearError } from '@/features/auth/authSlice'
import { OTP_TYPES } from '@/services/authService'

import './OTPPage.css'
import AuthLayout from './components/AuthLayout'
import OTPForm from './components/OTPForm'

const OTPPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user, isAuthenticated } = useSelector((state) => state.auth)

    // Redirect to login if no user data
    useEffect(() => {
        if (!user) {
            navigate('/login')
        }
    }, [user, navigate])

    // Redirect to dashboard after successful login
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard')
        }
    }, [isAuthenticated, navigate])

    // Clear errors when unmounting
    useEffect(() => {
        return () => {
            dispatch(clearError())
        }
    }, [dispatch])

    const handleOTPSubmit = async ({ otp, password }) => {
        try {
            await dispatch(setUserPassword({
                userid: user.userid,
                password: password.trim(),
                otp: otp.trim()
            }));
        } catch (error) {
            console.error('Failed to set password:', error)
        }
    }

    const handleResendOTP = async () => {
        const result = await dispatch(requestOTP({
            userid: user.userid,
            otpTypeId: OTP_TYPES.FIRST_TIME_LOGIN
        }))

        return requestOTP.fulfilled.match(result)
    }

    return (
        <AuthLayout>
            <OTPForm
                onSubmit={handleOTPSubmit}
                onResendOTP={handleResendOTP}
                user={user}
                title="Set up your account"
                submitLabel="Complete Setup"
            />
        </AuthLayout>
    )
}

export default OTPPage
